var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"form__checkbox",class:{error: _vm.error}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('eventChange', $event.target.checked)}}}),_c('pre'),_vm._v(" "+_vm._s(_vm.placeholder)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }